<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="hideNdcObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>

            <div class="right-content">
                <div class="lefttext">
                    <p class="paragrapgh">NDC Flights</p>
                    <p>Trigger for NDC flights</p>
                </div>
                <div class="allbtns">
                    <b-switch :rounded="true" :value="hideNdcObj.isActive" v-model="hideNdcObj.isActive" @input="hideNdc"
                        :left-label="true">{{ hideNdcObj.isActive ? 'Active' : 'Inactive' }}
                    </b-switch>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "",
    props: {
        value: {
            type: [Object],
        },
    },
    data() {
        return {
            hideNdcObj: this.value
                ? this.value
                : {
                    name: "hideNdc",
                    isActive: false,
                    type: "air",
                    message: "Trigger for NDC flights",
                },
        };
    },
    methods: {
        hideNdc() {
            this.$emit("hideNdc", this.hideNdcObj);
        },
    },
    mounted() {
        this.hideNdcObj.type = "air";
        this.hideNdcObj.message = this.buildMessage;
        this.$emit("hideNdc", this.hideNdcObj);
    },
    computed: {
        buildMessage() {
            var string = "Trigger for NDC flights";

            return string;
        },
    },
    watch: {
        value: {
            handler(newVal, prevVal) {
                if (this.value) {
                    this.hideNdcObj = this.value;
                }
                this.hideNdcObj.type = "air";
                this.hideNdcObj.message = this.buildMessage;
                this.$emit("hideNdc", this.hideNdcObj);

            },
            deep: true,
        },
    },
};
</script>
  